import { render } from "./Profile.vue?vue&type=template&id=7bff07ac&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=7bff07ac&scoped=true&lang=css"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bff07ac"]])

export default __exports__